"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.unit_of_measurement = exports.register_type = exports.tariff_type = exports.process_type = exports.readability = exports.profile = exports.physical_status = exports.metering_direction = exports.meter_type = exports.administrative_status = exports.energy_type = exports.deviation_type = exports.type = exports.status = exports.Residents = exports.HouseType = void 0;
exports.HouseType = {
    VRIJSTAAND: 'vrijstaand',
    TWEEONDEREENKAP: '2onder1kap',
    HOEK: 'hoek',
    RIJTJE: 'rijtje',
    APPARTEMENT: 'appartement'
};
exports.Residents = {
    1: 'ONE',
    2: 'TWO',
    3: 'THREE',
    4: 'FOUR',
    5: 'FIVE',
    6: 'SIX',
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6
};
/**
 * Whether to increase the current monthly billing
 */
exports.status = {
    INCREASE: 'increase',
    DECREASE: 'decrease',
    AS_IS: 'as_is'
};
/**
 * The type of consent given
 */
exports.type = {
    COLLECTION: 'collection_conditions',
    MONTHLY: 'monthly_collection',
    DAILY: 'daily_collection',
    FIFTEEN_MINUTE: '15_minute'
};
/**
 * Type of Deviation (Hoog or Laag)
 */
exports.deviation_type = {
    HOOG: 'H',
    LAAG: 'L'
};
/**
 * Energy type
 */
exports.energy_type = {
    GAS: 'gas',
    ELECTRICITY: 'electricity'
};
/**
 * Administrative status smart meter
 */
exports.administrative_status = {
    ON: 'AAN',
    OFF: 'UIT'
};
/**
 * 2 possible types: CVN or SLM
 */
exports.meter_type = {
    CONVENTIONAL: 'CVN',
    SMART: 'SLM',
    READABLE_FROM_DISTANCE_BUT_NOT_TOGGLEABLE: 'DUN',
    READABLE_FROM_DISTANCE_AND_TOGGLEABLE: 'DUS',
    DAILY_REMOTE_READABLE: 'M01',
    OTHER: 'M02'
};
/**
 * Whether it is supply only, back-supply only, or a combination
 */
exports.metering_direction = {
    DELIVERY_CONSUMPTION: 'LVR',
    RETURN_DELIVERY: 'TLV',
    COMBINATION: 'CMB',
    L: 'L'
};
/**
 * Physical status of the meter
 */
exports.physical_status = {
    ZERO: '000',
    IN_OPERATION: 'IBD',
    OUT_OF_OPERATION: 'UBD',
    DEMOLISHED: 'SLP',
    UNDER_CONSTRUCTION: 'IAL'
};
/**
 * Profile type of energy usage
 */
exports.profile = {
    E1A: 'E1A',
    E1B: 'E1B',
    E1C: 'E1C',
    E2A: 'E2A',
    E2B: 'E2B',
    E3A: 'E3A',
    E3B: 'E3B',
    E3C: 'E3C',
    E3D: 'E3D',
    E4A: 'E4A',
    OPC: 'OPC',
    G1A: 'G1A',
    G2A: 'G2A',
    G2B: 'G2B',
    G2C: 'G2C',
    GGV: 'GGV',
    GKV: 'GKV',
    GXX: 'GXX',
    GIS: 'GIS',
    GIN: 'GIN'
};
/**
 * If the smart meter is readable
 */
exports.readability = {
    SMU: 'SMU',
    SMN: 'SMN'
};
/**
 * Reading process type
 */
exports.process_type = {
    PERIODIC_RECORD: 'PER',
    INTERN_RECORD: 'INI',
    INTERN_RECORD_PAYMENT: 'ACI',
    INTERN_PAYMENT: 'IB',
    MOVE_IN: 'MIN',
    SWITCH_IN: 'SWI',
    MOVE_OUT: 'MOT',
    SWITCH_OUT: 'SWO',
    FORCED_MOVE_OUT: 'FMO',
    END_OF_SERVICE: 'EOS',
    INSTALL_METER: 'INS',
    REMOVE_METER: 'REM',
    EXCHANGE_METER: 'EXC',
    OLD_EXCHANGE_METER: 'OXC',
    NEW_EXCHANGE_METER: 'NXC',
    METER_ON: 'ON',
    METER_OFF: 'OFF',
    SMART_METER: 'SMC'
};
/**
 * Tariff type
 */
exports.tariff_type = {
    NORMAL: 'N',
    LOW: 'L',
    REDELIVERY: 'T'
};
/**
 * Type of register
 */
exports.register_type = {
    LEVERING_LAAG: 'levering_laag',
    LEVERING_NORMAAL: 'levering_normaal',
    TERUGLEVERING_LAAG: 'teruglevering_laag',
    TERUGLEVERING_NORMAAL: 'teruglevering_normaal',
    LEVERING_GAS: 'levering_gas'
};
/**
 * Unit of measurement for the consumption fields
 */
exports.unit_of_measurement = {
    KWH: 'kwh',
    M3: 'm3'
};
